import { addDays, format, isAfter, isBefore, parseISO } from 'date-fns';
import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionM } from '../../oasis-sections/section-m';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint, TEMP_VERSION } from '../util';
import { UTCDate } from '@date-fns/utc';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
const MAX_DAYS_AFTER_START_OF_CARE = 59;
const consistencyMisAfter = (date1, date2) => {
    if (date1 && date2 && isAfter(parseISO(date1), parseISO(date2))) {
        return true;
    }
    return false;
};
// eslint-disable-next-line
export const sectionMConsistency = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        const payload = input;
        // M-consistency-3261 DATE ITEM CONSISTENCY: PATTERN 1
        // Each active item in the list below that contains a valid date (not blank) must be in the specified order.
        // If M0032_ROC_DT is equal to [^], then the following rules apply:
        // M0066_PAT_BIRTH_DT <
        // M1005_INP_DISCHARGE_DT <=
        // M0102_PHYSN_ORDRD_SOCROC_DT <=
        // M0030_START_CARE_DT <=
        // M1307_OLDST_STG2_ONST_DT <=
        // M0906_DC_TRAN_DTH_DT <=
        // M0090_INFO_COMPLETED_DT <=
        // Current date
        if (!payload.SectionA?.m0032) {
            // m0066
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m1005)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionA.m1005), 'MMM.dd.yyyy')} (M1005)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0102)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0102), 'MMM.dd.yyyy')} (M0102)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0030)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0030), 'MMM.dd.yyyy')} (M0030)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M0066 cannot be in the future.',
                    path: ['SectionA', 'm0066'],
                });
            }
            // m1005
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0102)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1005 has to be on or before ${format(parseISO(payload.SectionA.m0102), 'MMM.dd.yyyy')} (M0102)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0030)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1005 has to be on or before ${format(parseISO(payload.SectionA.m0030), 'MMM.dd.yyyy')} (M0030)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1005 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1005 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1005 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M1005 cannot be in the future.',
                    path: ['SectionA', 'm1005'],
                });
            }
            // m0102
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0030) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0030), 'MMM.dd.yyyy')} (M0030)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionM?.m1307DT) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0102 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0906) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0090) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M0102 cannot be in the future.',
                    path: ['SectionA', 'm0102'],
                });
            }
            // m0030
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0030 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M0030 cannot be in the future.',
                    path: ['SectionA', 'm0030'],
                });
            }
            // m1307
            if (consistencyMisAfter(payload.SectionM?.m1307DT, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1307 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionM', 'm1307DT'],
                });
            }
            if (consistencyMisAfter(payload.SectionM?.m1307DT, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M1307 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionM', 'm1307DT'],
                });
            }
            if (consistencyMisAfter(payload.SectionM?.m1307DT, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M1307 cannot be in the future.',
                    path: ['SectionM', 'm1307DT'],
                });
            }
            // m0906
            if (consistencyMisAfter(payload.SectionA?.m0906, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 M0906 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0906'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0906, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M0906 cannot be in the future.',
                    path: ['SectionA', 'm0906'],
                });
            }
            // M0906 must be on or after M0030
            if (payload.SectionA?.m0906 &&
                payload.SectionA?.m0030 &&
                isBefore(parseISO(payload.SectionA.m0906), parseISO(payload.SectionA.m0030))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 Warning: M0906 cannot be before the start of care date (M0030: ${format(new UTCDate(payload.SectionA.m0030), 'yyyy-MM-dd')}).`,
                    path: ['SectionA', 'm0906'],
                });
            }
            // M0906 must not be after M0030 + 59 days
            if (payload.SectionA?.m0906 &&
                payload.SectionA?.m0030 &&
                consistencyMisAfter(payload.SectionA?.m0906, format(addDays(parseISO(payload.SectionA.m0030), MAX_DAYS_AFTER_START_OF_CARE), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 Warning: M0906 cannot be more than 59 days after the start of care date (End date: ${format(addDays(parseISO(payload.SectionA.m0030), MAX_DAYS_AFTER_START_OF_CARE), 'yyyy-MM-dd')}).`,
                    path: ['SectionA', 'm0906'],
                });
            }
            // m0090
            if (consistencyMisAfter(payload.SectionA?.m0090, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3261 Warning: M0090 cannot be in the future.',
                    path: ['SectionA', 'm0090'],
                });
            }
            if (payload.SectionA?.m0090 &&
                payload.SectionA?.m0030 &&
                isBefore(parseISO(payload.SectionA?.m0090), parseISO(payload.SectionA?.m0030))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 Warning: M0090 cannot be before the start of care date (M0030: ${format(new UTCDate(payload.SectionA.m0030), 'yyyy-MM-dd')}).`,
                    path: ['SectionA', 'm0090'],
                });
            }
            // M0090 must not be after M0030 + 59 days
            if (payload.SectionA?.m0090 &&
                payload.SectionA?.m0030 &&
                consistencyMisAfter(payload.SectionA?.m0090, format(addDays(parseISO(payload.SectionA.m0030), MAX_DAYS_AFTER_START_OF_CARE), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3261 Warning: M0090 cannot be more than 59 days after the start of care date (End date: ${format(addDays(parseISO(payload.SectionA.m0030), MAX_DAYS_AFTER_START_OF_CARE), 'yyyy-MM-dd')}).`,
                    path: ['SectionA', 'm0090'],
                });
            }
        }
        // M-consistency-3271 DATE ITEM CONSISTENCY: PATTERN 2
        // Each active item in the list below that contains a valid date (not blank) must be in the specified order.
        // If M0032_ROC_DT is NOT equal to [^], then the following rules apply:
        // M0066_PAT_BIRTH_DT <
        // M0030_START_CARE_DT <=
        // M1005_INP_DISCHARGE_DT <=
        // M0102_PHYSN_ORDRD_SOCROC_DT <=
        // M0032_ROC_DT <=
        // M1307_OLDST_STG2_ONST_DT <=
        // M0906_DC_TRAN_DTH_DT <=
        // M0090_INFO_COMPLETED_DT <=
        // Current date
        if (payload.SectionA?.m0032) {
            // m0066
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0030)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0030), 'MMM.dd.yyyy')} (M0030)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m1005)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m1005), 'MMM.dd.yyyy')} (M1005)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0102)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0102), 'MMM.dd.yyyy')} (M0102)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0032)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0032), 'MMM.dd.yyyy')} (M0032)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0066 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0066'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0066, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M0066 cannot be in the future.',
                    path: ['SectionA', 'm0066'],
                });
            }
            // m0030
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m1005)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionA.m1005), 'MMM.dd.yyyy')} (M1005)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0102)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0102), 'MMM.dd.yyyy')} (M0102)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0032)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0032), 'MMM.dd.yyyy')} (M0032)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0030 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0030'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0030, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M0030 cannot be in the future.',
                    path: ['SectionA', 'm0030'],
                });
            }
            // m1005
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0102)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 m1005 has to be on or before ${format(parseISO(payload.SectionA.m0102), 'MMM.dd.yyyy')} (M0102)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0032)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 m1005 has to be on or before ${format(parseISO(payload.SectionA.m0032), 'MMM.dd.yyyy')} (M0032)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 m1005 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 m1005 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 m1005 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm1005'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m1005, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M1005 cannot be in the future.',
                    path: ['SectionA', 'm1005'],
                });
            }
            // m0102
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0032) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0032), 'MMM.dd.yyyy')} (M0032)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionM?.m1307DT) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0102 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0906) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, payload.SectionA?.m0090) &&
                !isTimepoint([OASIS.DTH], payload.SectionA?.m0100)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0102 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0102'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0102, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M0102 cannot be in the future.',
                    path: ['SectionA', 'm0102'],
                });
            }
            // m0032
            if (consistencyMisAfter(payload.SectionA?.m0032, payload.SectionM?.m1307DT)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0032 has to be on or before ${format(parseISO(payload.SectionM.m1307DT), 'MMM.dd.yyyy')} (M1307)`,
                    path: ['SectionA', 'm0032'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0032, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0032 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionA', 'm0032'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0032, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0032 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0032'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0032, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M0032 cannot be in the future.',
                    path: ['SectionA', 'm0032'],
                });
            }
            // m1307
            if (consistencyMisAfter(payload.SectionM?.m1307DT, payload.SectionA?.m0906)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M1307 has to be on or before ${format(parseISO(payload.SectionA.m0906), 'MMM.dd.yyyy')} (M0906)`,
                    path: ['SectionM', 'm1307DT'],
                });
            }
            if (consistencyMisAfter(payload.SectionM?.m1307DT, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M1307 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionM', 'm1307DT'],
                });
            }
            if (consistencyMisAfter(payload.SectionM?.m1307DT, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M1307 cannot be in the future.',
                    path: ['SectionM', 'm1307DT'],
                });
            }
            // m0906
            if (consistencyMisAfter(payload.SectionA?.m0906, payload.SectionA?.m0090)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0906 has to be on or before ${format(parseISO(payload.SectionA.m0090), 'MMM.dd.yyyy')} (M0090)`,
                    path: ['SectionA', 'm0906'],
                });
            }
            if (consistencyMisAfter(payload.SectionA?.m0906, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 M0906 has to be on or before ${format(new UTCDate(), 'yyyy-MM-dd')}, 'MMM.dd.yyyy')} (current date)`,
                    path: ['SectionA', 'm0906'],
                });
            }
            // m0090
            if (consistencyMisAfter(payload.SectionA?.m0090, format(new UTCDate(), 'yyyy-MM-dd'))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-3271 Warning: M0090 cannot be in the future.',
                    path: ['SectionA', 'm0090'],
                });
            }
            if (payload.SectionA?.m0090 &&
                payload.SectionA?.m0032 &&
                isBefore(parseISO(payload.SectionA?.m0090), parseISO(payload.SectionA?.m0032))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-3271 Warning: M0090 cannot be before the resumption of care date (M0032: ${format(new UTCDate(payload.SectionA.m0032), 'yyyy-MM-dd')}).`,
                    path: ['SectionA', 'm0090'],
                });
            }
        }
        // M-consistency-5681 (a) If M0100_ASSMT_REASON = [01,03], and M1322_NBR_PRSULC_STG1 and M1311_NBR_PRSULC_STG2_A1 and M1311_NBR_PRSULC_STG3_B1 and M1311_NBR_PRSULC_STG4_C1 are all equal to [00,^], then if M1324_STG_PRBLM_ULCER is active it must be equal to [NA].
        if (isTimepoint([OASIS.ROC, OASIS.SOC], payload.SectionA?.m0100) &&
            [
                payload.SectionM?.m1322,
                payload.SectionM?.m1311?.m1311a1,
                payload.SectionM?.m1311?.m1311b1,
                payload.SectionM?.m1311?.m1311c1,
            ].every((item) => !item || ['0', '00'].includes(item || '')) &&
            isActive(SectionM.m1324, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1324 !== 'NA') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5681 (a) If M1322 and M1311A1 through M1311C1 are all equal to 0 or empty, then M1324 must be equal to NA',
                path: ['SectionM', 'm1324'],
            });
        }
        // M-consistency-5681 (b) If M0100_ASSMT_REASON=[09], and if M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1 and M1311_NBR_PRSULC_STG4_C1 are all equal to [00,-,^], then M1324_STG_PRBLM_ULCER must be equal to [1, NA].
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
            [
                payload.SectionM?.m1322,
                payload.SectionM?.m1311?.m1311a1,
                payload.SectionM?.m1311?.m1311b1,
                payload.SectionM?.m1311?.m1311c1,
            ].every((item) => !item || ['0', '-', '', '00'].includes(item || '')) &&
            isActive(SectionM.m1324, TEMP_VERSION, payload.SectionA?.m0100) &&
            !['NA', '01'].includes(payload.SectionM?.m1324 || '')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5681 (b) If M1322 and M1311A1 through M1311C1 are all equal to 0, -, or empty, then M1324 must be equal to NA or 1',
                path: ['SectionM', 'm1324'],
            });
        }
        // M-consistency-5661 If M0100_ASSMT_REASON = [01,03], then none of the following items can be equal to [-]: M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, and M1311_NSTG_DEEP_TSUE_F1.
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            [
                payload.SectionM?.m1311?.m1311a1,
                payload.SectionM?.m1311?.m1311b1,
                payload.SectionM?.m1311?.m1311c1,
                payload.SectionM?.m1311?.m1311d1,
                payload.SectionM?.m1311?.m1311e1,
                payload.SectionM?.m1311?.m1311f1,
            ].some((item) => ['-'].includes(item || '')) &&
            isActive(SectionM.m1324, TEMP_VERSION, payload.SectionA?.m0100) &&
            !['NA', '01'].includes(payload.SectionM?.m1324 || '')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5661 None of the items from M1311A1 through M1311F1 can be empty.',
                path: ['SectionM', 'm1311'],
            });
        }
        // M-consistency-5132 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [1], then at least one of the following items must be greater than [00]: M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, and M1311_NSTG_DEEP_TSUE_F1.
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1306 === '1' &&
            ![
                payload.SectionM?.m1311?.m1311a1,
                payload.SectionM?.m1311?.m1311b1,
                payload.SectionM?.m1311?.m1311c1,
                payload.SectionM?.m1311?.m1311d1,
                payload.SectionM?.m1311?.m1311e1,
                payload.SectionM?.m1311?.m1311f1,
            ].some((item) => item && item > '0')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5132 If M1306 = 1, then at least one of the items from M1311A1 through M1311F1 must be greater than 0.',
                path: ['SectionM', 'm1311'],
            });
        }
        // M-consistency-5372 If M1311_NBR_PRSULC_STG2_A1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG2_A2 is active, then M1311_NBR_ULC_SOCROC_STG2_A2 must be
        // (a) less than or equal to M1311_NBR_PRSULC_STG2_A1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311a1 &&
            payload.SectionM?.m1311?.m1311a2 &&
            payload.SectionM?.m1311?.m1311a1 > '0' &&
            isActive(SectionM.m1311.fields.a2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311a2 > payload.SectionM?.m1311?.m1311a1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5372 If M1311A1 > 0, then M1311A2 must be less than or equal to M1311A1',
                path: ['SectionM', 'm1311', 'm1311a2'],
            });
        }
        // M-consistency-5373 If M1311_NBR_PRSULC_STG2_A1=[-], then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311a1 &&
            payload.SectionM?.m1311?.m1311a2 &&
            isActive(SectionM.m1311.fields.a2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311a2 === '-' &&
            payload.SectionM?.m1311?.m1311a2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5373 If M1311A1 = -, then M1311A2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311a2'],
            });
        }
        // M-consistency-4182 If M0100_ASSMT_REASON=[01,03,09] AND M1324_STG_PRBLM_ULCER=[02], then if M1311_NBR_PRSULC_STG2_A1 is active it must not equal [^] and it must be greater than [00].
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1324 === '02' &&
            isActive(SectionM.m1311, TEMP_VERSION, payload.SectionA?.m0100) &&
            (!payload.SectionM?.m1311?.m1311a1 || payload.SectionM?.m1311.m1311a1 === '0')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4182 If M1324 = Stage 2, then M1311A1 be greater than 0.',
                path: ['SectionM', 'm1311'],
            });
        }
        // M-consistency-5382 If M1311_NBR_PRSULC_STG3_B1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG3_B2 is active, then M1311_NBR_ULC_SOCROC_STG3_B2 must be
        // (a) less than or equal to M1311_NBR_PRSULC_STG3_B1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311b1 &&
            payload.SectionM?.m1311?.m1311b2 &&
            payload.SectionM?.m1311?.m1311b1 > '0' &&
            isActive(SectionM.m1311.fields.b2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311b2 > payload.SectionM?.m1311?.m1311b1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5382 If M1311B1 > 0, then M1311B2 must be less than or equal to M1311B1',
                path: ['SectionM', 'm1311', 'm1311b2'],
            });
        }
        // M-consistency-5383 If M1311_NBR_PRSULC_STG3_B1=[-], then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311b1 &&
            payload.SectionM?.m1311?.m1311b2 &&
            isActive(SectionM.m1311.fields.b2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311b2 === '-' &&
            payload.SectionM?.m1311?.m1311b2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5383 If M1311B1 = -, then M1311B2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311b2'],
            });
        }
        // M-consistency-4192 If M0100_ASSMT_REASON=[01,03,09] AND M1324_STG_PRBLM_ULCER=[03], then if M1311_NBR_PRSULC_STG3_B1 is active it must not equal [^] and it must be greater than [00].
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1324 === '03' &&
            isActive(SectionM.m1311, TEMP_VERSION, payload.SectionA?.m0100) &&
            (!payload.SectionM.m1311?.m1311b1 || payload.SectionM?.m1311.m1311b1 === '0')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4192 If M1324 = Stage 3, then M1311B1 must be greater than 0.',
                path: ['SectionM', 'm1311'],
            });
        }
        // M-consistency-5392 If M1311_NBR_PRSULC_STG4_C1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG4_C2 is active, then M1311_NBR_ULC_SOCROC_STG4_C2 must be
        // (a) less than or equal to M1311_NBR_PRSULC_STG4_C1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311c1 &&
            payload.SectionM?.m1311?.m1311c2 &&
            payload.SectionM?.m1311?.m1311c1 > '0' &&
            isActive(SectionM.m1311.fields.c2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311c2 > payload.SectionM?.m1311?.m1311c1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5392 If M1311C1 > 0, then M1311C2 must be less than or equal to M1311C1',
                path: ['SectionM', 'm1311', 'm1311c2'],
            });
        }
        // M-consistency-5393 If M1311_NBR_PRSULC_STG4_C1=[-], then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311c1 &&
            payload.SectionM?.m1311?.m1311c2 &&
            isActive(SectionM.m1311.fields.c2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311c2 === '-' &&
            payload.SectionM?.m1311?.m1311c2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5393 If M1311C1 = -, then M1311C2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311c2'],
            });
        }
        // M-consistency-4202 If M0100_ASSMT_REASON = [01,03,09], AND M1324_STG_PRBLM_ULCER=[04], then if M1311_NBR_PRSULC_STG4_C1 is active it must not equal [^] and it must be greater than [00].
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1324 === '04' &&
            isActive(SectionM.m1311, TEMP_VERSION, payload.SectionA?.m0100) &&
            (!payload.SectionM.m1311?.m1311c1 || payload.SectionM?.m1311.m1311c1 === '0')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4202 If M1324 = Stage 4, then M1311C1 must be greater than 0.',
                path: ['SectionM', 'm1311'],
            });
        }
        // M-consistency-5402 If M1311_NSTG_DRSG_D1 is greater than 0, and M1311_NSTG_DRSG_SOCROC_D2 is active, then M1311_NSTG_DRSG_SOCROC_D2 must be
        // (a) less than or equal to M1311_NSTG_DRSG_D1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311d1 &&
            payload.SectionM?.m1311?.m1311d2 &&
            payload.SectionM?.m1311?.m1311d1 > '0' &&
            isActive(SectionM.m1311.fields.d2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311d2 > payload.SectionM?.m1311?.m1311d1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5402 If M1311D1 > 0, then M1311D2 must be less than or equal to M1311D1',
                path: ['SectionM', 'm1311', 'm1311d2'],
            });
        }
        // M-consistency-5403 If M1311_NSTG_DRSG_D1=[-], then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311d1 &&
            payload.SectionM?.m1311?.m1311d2 &&
            isActive(SectionM.m1311.fields.d2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311d2 === '-' &&
            payload.SectionM?.m1311?.m1311d2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5403 If M1311D1 = -, then M1311D2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311d2'],
            });
        }
        // M-consistency-5412 If M1311_NSTG_CVRG_E1 is greater than 0, and M1311_NSTG_CVRG_SOCROC_E2 is active, then M1311_NSTG_CVRG_SOCROC_E2 must be
        // (a) less than or equal to M1311_NSTG_CVRG_E1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311e1 &&
            payload.SectionM?.m1311?.m1311e2 &&
            payload.SectionM?.m1311?.m1311e1 > '0' &&
            isActive(SectionM.m1311.fields.e2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311e2 > payload.SectionM?.m1311?.m1311e1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5412 If M1311E1 > 0, then M1311E2 must be less than or equal to M1311E1',
                path: ['SectionM', 'm1311', 'm1311e2'],
            });
        }
        // M-consistency-5413 If M1311_NSTG_CVRG_E1=[-], then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311e1 &&
            payload.SectionM?.m1311?.m1311e2 &&
            isActive(SectionM.m1311.fields.e2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311e2 === '-' &&
            payload.SectionM?.m1311?.m1311e2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5403 If M1311E1 = -, then M1311E2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311e2'],
            });
        }
        // M-consistency-5422 If M1311_NSTG_DEEP_TSUE_F1 is greater than 0, and M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, then M1311_NSTG_DEEP_TSUE_SOCROC_F2 must be
        // (a) less than or equal to M1311_NSTG_DEEP_TSUE_F1, or (b) equal to dash [-].
        if (payload.SectionM?.m1311?.m1311f1 &&
            payload.SectionM?.m1311?.m1311f2 &&
            payload.SectionM?.m1311?.m1311f1 > '0' &&
            isActive(SectionM.m1311.fields.f2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311f2 > payload.SectionM?.m1311?.m1311f1) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5412 If M1311F1 > 0, then M1311F2 must be less than or equal to M1311F1',
                path: ['SectionM', 'm1311', 'm1311f2'],
            });
        }
        // M-consistency-5423 If M1311_NSTG_DEEP_TSUE_F1=[-], then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must be equal to [-].
        if (payload.SectionM?.m1311?.m1311f1 &&
            payload.SectionM?.m1311?.m1311f2 &&
            isActive(SectionM.m1311.fields.f2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311f2 === '-' &&
            payload.SectionM?.m1311?.m1311f2 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5403 If M1311F1 = -, then M1311F2 must be equal to -.',
                path: ['SectionM', 'm1311', 'm1311f2'],
            });
        }
        // M-consistency-4171 If M0100_ASSMT_REASON =[01,03], AND M1324_STG_PRBLM_ULCER=[01], then if M1322_NBR_PRSULC_STG1 is active it must be > [00].
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            payload.SectionM?.m1324 === '01' &&
            isActive(SectionM.m1322, TEMP_VERSION, payload.SectionA?.m0100) &&
            (!payload.SectionM.m1322 || (payload.SectionM?.m1322 && payload.SectionM.m1322 === '00'))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4171 If M1324 = Stage 1, then  M1322 must be > 0.',
                path: ['SectionM', 'm1322'],
            });
        }
    }
    else if (!field) {
        // section level
        // eslint-disable-next-line
        const payload = input;
    }
    else {
        // field level
    }
};
// M-consistency-3261 DATE ITEM CONSISTENCY: PATTERN 1
// Each active item in the list below that contains a valid date (not blank) must be in the specified order.
// If M0032_ROC_DT is equal to [^], then the following rules apply:
// M0066_PAT_BIRTH_DT <
// M1005_INP_DISCHARGE_DT <=
// M0102_PHYSN_ORDRD_SOCROC_DT <=
// M0030_START_CARE_DT <=
// M1307_OLDST_STG2_ONST_DT <=
// M0906_DC_TRAN_DTH_DT <=
// M0090_INFO_COMPLETED_DT <=
// Current date
// M-consistency-3271 DATE ITEM CONSISTENCY: PATTERN 2
// Each active item in the list below that contains a valid date (not blank) must be in the specified order.
// If M0032_ROC_DT is NOT equal to [^], then the following rules apply:
// M0066_PAT_BIRTH_DT <
// M0030_START_CARE_DT <=
// M1005_INP_DISCHARGE_DT <=
// M0102_PHYSN_ORDRD_SOCROC_DT <=
// M0032_ROC_DT <=
// M1307_OLDST_STG2_ONST_DT <=
// M0906_DC_TRAN_DTH_DT <=
// M0090_INFO_COMPLETED_DT <=
// Current date
// M-consistency-5681
// (a) If M0100_ASSMT_REASON = [01,03], and M1322_NBR_PRSULC_STG1 and M1311_NBR_PRSULC_STG2_A1 and M1311_NBR_PRSULC_STG3_B1 and M1311_NBR_PRSULC_STG4_C1 are all equal to [00,^], then if M1324_STG_PRBLM_ULCER is active it must be equal to [NA].
// (b) If M0100_ASSMT_REASON=[09], and if M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1 and M1311_NBR_PRSULC_STG4_C1 are all equal to [00,-,^], then M1324_STG_PRBLM_ULCER must be equal to [1, NA].
// M-consistency-5661 If M0100_ASSMT_REASON = [01,03], then none of the following items can be equal to [-]: M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, and M1311_NSTG_DEEP_TSUE_F1.
// M-consistency-5132 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [1], then at least one of the following items must be greater than [00]: M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, and M1311_NSTG_DEEP_TSUE_F1.
// M-consistency-5372 If M1311_NBR_PRSULC_STG2_A1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG2_A2 is active, then M1311_NBR_ULC_SOCROC_STG2_A2 must be
// (a) less than or equal to M1311_NBR_PRSULC_STG2_A1, or (b) equal to dash [-].
// M-consistency-5373 If M1311_NBR_PRSULC_STG2_A1=[-], then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must be equal to [-].
// M-consistency-4182 If M0100_ASSMT_REASON=[01,03,09] AND M1324_STG_PRBLM_ULCER=[02], then if M1311_NBR_PRSULC_STG2_A1 is active it must not equal [^] and it must be greater than [00].
// M-consistency-5382 If M1311_NBR_PRSULC_STG3_B1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG3_B2 is active, then M1311_NBR_ULC_SOCROC_STG3_B2 must be
// (a) less than or equal to M1311_NBR_PRSULC_STG3_B1, or (b) equal to dash [-].
// M-consistency-5383 If M1311_NBR_PRSULC_STG3_B1=[-], then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must be equal to [-].
// M-consistency-4192 If M0100_ASSMT_REASON=[01,03,09] AND M1324_STG_PRBLM_ULCER=[03], then if M1311_NBR_PRSULC_STG3_B1 is active it must not equal [^] and it must be greater than [00].
// M-consistency-5392 If M1311_NBR_PRSULC_STG4_C1 is greater than 0, and M1311_NBR_ULC_SOCROC_STG4_C2 is active, then M1311_NBR_ULC_SOCROC_STG4_C2 must be
// (a) less than or equal to M1311_NBR_PRSULC_STG4_C1, or (b) equal to dash [-].
// M-consistency-5393 If M1311_NBR_PRSULC_STG4_C1=[-], then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must be equal to [-].
// M-consistency-4202 If M0100_ASSMT_REASON = [01,03,09], AND M1324_STG_PRBLM_ULCER=[04], then if M1311_NBR_PRSULC_STG4_C1 is active it must not equal [^] and it must be greater than [00].
// M-consistency-5412 If M1311_NSTG_CVRG_E1 is greater than 0, and M1311_NSTG_CVRG_SOCROC_E2 is active, then M1311_NSTG_CVRG_SOCROC_E2 must be
// (a) less than or equal to M1311_NSTG_CVRG_E1, or (b) equal to dash [-].
// M-consistency-5413 If M1311_NSTG_CVRG_E1=[-], then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must be equal to [-].
// M-consistency-5422 If M1311_NSTG_DEEP_TSUE_F1 is greater than 0, and M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, then M1311_NSTG_DEEP_TSUE_SOCROC_F2 must be
// (a) less than or equal to M1311_NSTG_DEEP_TSUE_F1, or (b) equal to dash [-].
// M-consistency-5423 \tIf M1311_NSTG_DEEP_TSUE_F1=[-], then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must be equal to [-].
// M-consistency-5402 If M1311_NSTG_DRSG_D1 is greater than 0, and M1311_NSTG_DRSG_SOCROC_D2 is active, then M1311_NSTG_DRSG_SOCROC_D2 must be
// (a) less than or equal to M1311_NSTG_DRSG_D1, or (b) equal to dash [-].
// M-consistency-5403 \tIf M1311_NSTG_DRSG_D1=[-], then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must be equal to [-].
// M-consistency-4171 If M0100_ASSMT_REASON =[01,03], AND M1324_STG_PRBLM_ULCER=[01], then if M1322_NBR_PRSULC_STG1 is active it must be > [00].
